import React from "react";
import { Icon } from "@iconify/react";

const LecturesCard = ({ lecture }) => {
  return (
    <div className="bg-white border border-gray-100 rounded-3xl hover:border-indigo-100 transition-all duration-300 hover:shadow-xl hover:shadow-indigo-950/[0.02] flex flex-col justify-between overflow-hidden group">
      
      {/* Video Container */}
      <div className="relative aspect-video bg-gray-50 overflow-hidden">
        <iframe
          className="w-full h-full"
          src={lecture?.videoUrl}
          title={lecture?.videoTitle || "YouTube video player"}
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share; fullscreen"
          allowFullScreen
        />
      </div>

      {/* Info Body */}
      <div className="p-6 flex-grow flex flex-col justify-between">
        <div>
          {/* Author/Speaker badge */}
          <div className="flex items-center gap-2 mb-3">
            <span className="flex items-center gap-1 text-[10px] font-bold text-indigo-600 bg-indigo-50 border border-indigo-100/50 rounded-full px-2.5 py-1 uppercase tracking-wider">
              <Icon icon="solar:user-bold" className="w-3 h-3" />
              {lecture?.lecturersName || "CareSee Therapist"}
            </span>
          </div>

          {/* Title */}
          <h3 className="font-heading text-lg font-bold text-gray-900 mb-2 leading-snug line-clamp-2 group-hover:text-indigo-600 transition-colors">
            {lecture?.videoTitle}
          </h3>

          {/* Description */}
          <p className="text-xs text-gray-500 leading-relaxed line-clamp-3">
            {lecture?.videoDes || "Educational video explaining therapy procedures and training modules."}
          </p>
        </div>
      </div>
    </div>
  );
};

export default LecturesCard;
